import styled from 'styled-components';
import {
  Flex,
  FlexColumn,
  IconButton,
  Chip,
} from '@elementary/common-ui/components';

export const Wrapper = styled(FlexColumn)`
  height: 100%;
  gap: 24px;
  position: relative;
  overflow: hidden;
`;

export const Header = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  padding: 24px 16px 8px 16px;
`;

export const HeaderNavigation = styled(Flex)`
  align-items: center;
  gap: 16px;
  min-width: 0;
  flex: 1;
`;

export const BackButton = styled(IconButton)`
  svg path {
    fill: ${({ theme }) => theme.palette.common.gray14} !important;
  }

  &:hover svg path {
    fill: ${({ theme }) => theme.palette.common.black} !important;
  }
`;

export const HeaderActions = styled(Flex)`
  align-items: center;
  gap: 12px;
`;

export const SelectedCountLabel = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.palette.common.gray11};
`;

export const TableContainer = styled(FlexColumn)`
  flex: 1;
  min-height: 0;
  padding: 0 16px 16px 16px;
  z-index: 0;
`;

export const EmptyState = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 16px;
  color: ${({ theme }) => theme.palette.common.gray11};
`;

export const ClickableChip = styled(Chip)`
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const CellFlex = styled(Flex)`
  align-items: center;
  gap: 8px;
  max-width: 100%;
  overflow: hidden;
`;

export const FixedChipWrapper = styled.div`
  flex-shrink: 0;
`;

export const ElasticChipWrapper = styled.div`
  min-width: 0;
  flex: 1;

  .MuiChip-root {
    max-width: 100%;
  }

  .MuiChip-label {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
